import { render, staticRenderFns } from "./Certify.vue?vue&type=template&id=39d687ce&"
import script from "./Certify.vue?vue&type=script&lang=js&"
export * from "./Certify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports